<app-form
    (onDirty)="emit_onDirty($event)"
    (onEscape)="emit_onEscape()"
    (onEnter)="emit_onEnter()"
    [template]="editForm"
/>

<ng-template #editForm>
    <app-input-control
        [control]="control_email"
        [label]="'email'"
        [readonly]="true"
    />
    <app-input-control #focus
        [autofocus]="true"
        [control]="control_firstName"
        [label]="'first name'"
        [lockOnLoad]="true"
        [placeholder]="'enter your first name'"
        [resetValue]="value_firstName"
    />
    <app-input-control
        [control]="control_lastName"
        [label]="'last name'"
        [lockOnLoad]="true"
        [placeholder]="'enter your last name (optional)'"
        [resetValue]="value_lastName"
    />
    <app-input-control
        [control]="control_applicationName"
        [label]="'application name'"
        [lockOnLoad]="true"
        [placeholder]="'name visible to others (empty = first + last name, else your email)'"
        [resetValue]="value_applicationName"
    />
    <app-input-control
        [control]="control_correspondenceName"
        [label]="'correspondence name'"
        [lockOnLoad]="true"
        [placeholder]="'salutation in emails, e.g. Mr. J. Jansen (empty = application name)'"
        [resetValue]="value_correspondenceName"
    />
</ng-template>
